module.exports = __webpack_public_path__ + "static/media/et_4.5093ff4d.png";